<template>
    <v-layout column align-center justify-center 
      class="base-loader"
      :style="`--p-height: ${height}px`"
    >
        <img src="../../assets/icons/course.png" alt="logo" width="auto" height="160px">
        <div class="text-message mt-3">{{infoText}}</div>
    </v-layout>
  </template>
  
  <script>
  export default {
    props: {
      height: {
        type: Number,
        default: 215
      },
      infoText: {
        type: String,
        default: ""
      },
    }
  };
  </script>
  
<style>
    .base-loader {
        height: calc(100vh - var(--p-height));
    }

    .text-message {
        color: #616161;
        font-size: 20px;
        letter-spacing: 0.2px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/base/InfoBase.vue